// extracted by mini-css-extract-plugin
export var creator = "Creator-module--creator--yjs84";
export var creatorDescription = "Creator-module--creatorDescription--ZCRBm";
export var creatorHeaderDesktop = "Creator-module--creatorHeaderDesktop--7UVh9";
export var creatorHeaderMobile = "Creator-module--creatorHeaderMobile--pZj9f";
export var creatorImage = "Creator-module--creatorImage--hNsjm";